module.exports = __webpack_public_path__ + "static/media/5.907a7b5c.svg";